import React from 'react';
import { css } from '@emotion/react';
import SiteSearch from '../site-search/site-search';

const corporateFooterStyles = {
    footerMobileInfo: css({
        maxWidth: '250px',
        marginBottom: '32px',
        '@media (min-width: 1024px)': {
            display: 'none',
        },
    }),
    searchbarWrapper: css({
        maxWidth: '325px',
        marginBottom: '48px',
        fontSize: '18px',
        lineHeight: '28px',
        '@media (min-width: 1024px)': {
            display: 'none',
            paddingRight: '0',
        },
    }),
};

interface CorporateFooterProps {
    links?: Array<{
        title?: string | null;
        links?: Array<{
            title?: string | null;
            url?: string | null;
            className?: string | null;
            sublinks?: Array<{
                title?: string | null;
                url?: string | null;
                className?: string | null;
                sublinks?: Array<{
                    title?: string | null;
                    url?: string | null;
                }>;
            }>;
        }> | null;
    }> | null;
    staticDisclaimerCopy?: string | null;
    dynamicFooterDisclaimers?: ReadonlyArray<{
        contentBefore?: string | null;
        content?: string | null;
        pageMatch?: string | null;
    }>;
    currentPath?: string;
}

const CorporateFooter: React.FC<CorporateFooterProps> = () => (
    <>
        <div css={corporateFooterStyles.footerMobileInfo}>
            801 Industrial Blvd
            <br />
            Gallatin, TN 37066
            <br />
        </div>
        <div css={corporateFooterStyles.searchbarWrapper}>
            <SiteSearch />
        </div>
    </>
);
export default CorporateFooter;
